export const invoiceVisaTags = ['invoice-visa'];
